<template>
  <div class="box-social" :class="reseau"> 
    <i class="fab fa-facebook-square"></i>
    <p><slot></slot></p>
    <a :href="lien" class="link"><i class="fas fa-external-link-alt"></i></a>
    <em class="date"> {{ date }} </em>
  </div> 
</template>

<script>
  export default {
    props: ['lien', 'titleItem', 'reseau', 'date']
  }
</script>

<style>
  .box-social  {
    width: 100%;
    background: white;
    border-radius: 15px;
    padding: 20px;
    box-shadow: 0px 0px 15px rgba(0,0,0,0.2); 
    margin-bottom: 40px;  
    text-align: left;
    position: relative;
  }

  .box-social p  {  font-size: 14px; }
  .box-social .link  {  color: #495057; }
  .box-social .date  {  font-size: 12px; }
  
  .box-social .fa-facebook-square {
    font-size: 44px;
    display: inline-block;
    margin-right: 10px;
    top: 1px;
    position: absolute;
    top: -15px;
    right: -25px;
    font-weight: 900;
  }
  
  .box-social.twitter:before {  content: "\f099"; color: #00acee; }
  .box-social.twitter.date, .box-social.twitter .link:hover  { color: #00acee; }

  .box-social.facebook .fa-facebook-square { content: "\f082"; color: #3b5998; }
  .box-social.facebook.date, .box-social.facebook .link:hover  { color: #3b5998; }

  .box-social.linkedin:before {  content: "\f08c"; color: #0077b5; }
  .box-social.linkedin.date, .box-social.linkedin .link:hover  { color: #0077b5; }


</style>
